import { isString } from 'coreOld/utils';

const PartNumberHelper = {
  toValue: (partNumber: string | null): string | null => {
    if (!partNumber || !isString(partNumber)) {
      return null;
    }

    return partNumber.replace(/ /g, '_');
  },

  toLabel: (partNumber: string | null): string | null => {
    if (!partNumber || !isString(partNumber)) {
      return null;
    }

    return partNumber.replace(/_/g, ' ');
  },

  areTheSame: (firstPartNumber: string | null, secondPartNumber: string | null): boolean => {
    const firstValue = PartNumberHelper.toValue(firstPartNumber);
    const secondValue = PartNumberHelper.toValue(secondPartNumber);

    return firstValue === secondValue;
  },

  getPartNumberFromRecord: (record: {
    number: string | null;
    part: string | null;
  }): string | null => record.number || record.part || null,
};

export default PartNumberHelper;
